// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_comp_plan_res_values.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "stcs_cmw";

/** v3.0.2 */
export interface StcsCompPlanResValues {
  id: string;
  version: string;
  meta: StcsCompPlanResValuesMeta | undefined;
  pnl_map: { [key: string]: StcsCompPlanResValuesItem };
  bs_map: { [key: string]: StcsCompPlanResValuesItem };
  cf_map: { [key: string]: StcsCompPlanResValuesItem };
  is_draft: boolean;
}

export interface StcsCompPlanResValues_PnlMapEntry {
  key: string;
  value: StcsCompPlanResValuesItem | undefined;
}

export interface StcsCompPlanResValues_BsMapEntry {
  key: string;
  value: StcsCompPlanResValuesItem | undefined;
}

export interface StcsCompPlanResValues_CfMapEntry {
  key: string;
  value: StcsCompPlanResValuesItem | undefined;
}

export interface StcsCompPlanResValuesMeta {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  fpna_begin_date_string: string;
  fpna_end_date_string: string;
  /**
   * TODO
   * string plan_data_begin_date_string = 5;
   * string plan_data_end_date_string = 6;
   */
  obj_created_iso_utc: string;
  obj_updated_iso_utc: string;
}

export interface StcsCompPlanResValuesItem {
  values_map: { [key: string]: number };
}

export interface StcsCompPlanResValuesItem_ValuesMapEntry {
  key: string;
  value: number;
}

function createBaseStcsCompPlanResValues(): StcsCompPlanResValues {
  return { id: "", version: "", meta: undefined, pnl_map: {}, bs_map: {}, cf_map: {}, is_draft: false };
}

export const StcsCompPlanResValues: MessageFns<StcsCompPlanResValues> = {
  encode(message: StcsCompPlanResValues, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.version !== "") {
      writer.uint32(18).string(message.version);
    }
    if (message.meta !== undefined) {
      StcsCompPlanResValuesMeta.encode(message.meta, writer.uint32(26).fork()).join();
    }
    Object.entries(message.pnl_map).forEach(([key, value]) => {
      StcsCompPlanResValues_PnlMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    Object.entries(message.bs_map).forEach(([key, value]) => {
      StcsCompPlanResValues_BsMapEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    Object.entries(message.cf_map).forEach(([key, value]) => {
      StcsCompPlanResValues_CfMapEntry.encode({ key: key as any, value }, writer.uint32(50).fork()).join();
    });
    if (message.is_draft !== false) {
      writer.uint32(56).bool(message.is_draft);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanResValues {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanResValues();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.meta = StcsCompPlanResValuesMeta.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = StcsCompPlanResValues_PnlMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pnl_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = StcsCompPlanResValues_BsMapEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.bs_map[entry5.key] = entry5.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = StcsCompPlanResValues_CfMapEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.cf_map[entry6.key] = entry6.value;
          }
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.is_draft = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanResValues {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      meta: isSet(object.meta) ? StcsCompPlanResValuesMeta.fromJSON(object.meta) : undefined,
      pnl_map: isObject(object.pnl_map)
        ? Object.entries(object.pnl_map).reduce<{ [key: string]: StcsCompPlanResValuesItem }>((acc, [key, value]) => {
          acc[key] = StcsCompPlanResValuesItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      bs_map: isObject(object.bs_map)
        ? Object.entries(object.bs_map).reduce<{ [key: string]: StcsCompPlanResValuesItem }>((acc, [key, value]) => {
          acc[key] = StcsCompPlanResValuesItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      cf_map: isObject(object.cf_map)
        ? Object.entries(object.cf_map).reduce<{ [key: string]: StcsCompPlanResValuesItem }>((acc, [key, value]) => {
          acc[key] = StcsCompPlanResValuesItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      is_draft: isSet(object.is_draft) ? globalThis.Boolean(object.is_draft) : false,
    };
  },

  toJSON(message: StcsCompPlanResValues): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.meta !== undefined) {
      obj.meta = StcsCompPlanResValuesMeta.toJSON(message.meta);
    }
    if (message.pnl_map) {
      const entries = Object.entries(message.pnl_map);
      if (entries.length > 0) {
        obj.pnl_map = {};
        entries.forEach(([k, v]) => {
          obj.pnl_map[k] = StcsCompPlanResValuesItem.toJSON(v);
        });
      }
    }
    if (message.bs_map) {
      const entries = Object.entries(message.bs_map);
      if (entries.length > 0) {
        obj.bs_map = {};
        entries.forEach(([k, v]) => {
          obj.bs_map[k] = StcsCompPlanResValuesItem.toJSON(v);
        });
      }
    }
    if (message.cf_map) {
      const entries = Object.entries(message.cf_map);
      if (entries.length > 0) {
        obj.cf_map = {};
        entries.forEach(([k, v]) => {
          obj.cf_map[k] = StcsCompPlanResValuesItem.toJSON(v);
        });
      }
    }
    if (message.is_draft !== false) {
      obj.is_draft = message.is_draft;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanResValues>, I>>(base?: I): StcsCompPlanResValues {
    return StcsCompPlanResValues.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanResValues>, I>>(object: I): StcsCompPlanResValues {
    const message = createBaseStcsCompPlanResValues();
    message.id = object.id ?? "";
    message.version = object.version ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? StcsCompPlanResValuesMeta.fromPartial(object.meta)
      : undefined;
    message.pnl_map = Object.entries(object.pnl_map ?? {}).reduce<{ [key: string]: StcsCompPlanResValuesItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompPlanResValuesItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.bs_map = Object.entries(object.bs_map ?? {}).reduce<{ [key: string]: StcsCompPlanResValuesItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompPlanResValuesItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.cf_map = Object.entries(object.cf_map ?? {}).reduce<{ [key: string]: StcsCompPlanResValuesItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompPlanResValuesItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.is_draft = object.is_draft ?? false;
    return message;
  },
};

function createBaseStcsCompPlanResValues_PnlMapEntry(): StcsCompPlanResValues_PnlMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompPlanResValues_PnlMapEntry: MessageFns<StcsCompPlanResValues_PnlMapEntry> = {
  encode(message: StcsCompPlanResValues_PnlMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompPlanResValuesItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanResValues_PnlMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanResValues_PnlMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompPlanResValuesItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanResValues_PnlMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompPlanResValuesItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompPlanResValues_PnlMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompPlanResValuesItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanResValues_PnlMapEntry>, I>>(
    base?: I,
  ): StcsCompPlanResValues_PnlMapEntry {
    return StcsCompPlanResValues_PnlMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanResValues_PnlMapEntry>, I>>(
    object: I,
  ): StcsCompPlanResValues_PnlMapEntry {
    const message = createBaseStcsCompPlanResValues_PnlMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompPlanResValuesItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompPlanResValues_BsMapEntry(): StcsCompPlanResValues_BsMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompPlanResValues_BsMapEntry: MessageFns<StcsCompPlanResValues_BsMapEntry> = {
  encode(message: StcsCompPlanResValues_BsMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompPlanResValuesItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanResValues_BsMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanResValues_BsMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompPlanResValuesItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanResValues_BsMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompPlanResValuesItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompPlanResValues_BsMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompPlanResValuesItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanResValues_BsMapEntry>, I>>(
    base?: I,
  ): StcsCompPlanResValues_BsMapEntry {
    return StcsCompPlanResValues_BsMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanResValues_BsMapEntry>, I>>(
    object: I,
  ): StcsCompPlanResValues_BsMapEntry {
    const message = createBaseStcsCompPlanResValues_BsMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompPlanResValuesItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompPlanResValues_CfMapEntry(): StcsCompPlanResValues_CfMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompPlanResValues_CfMapEntry: MessageFns<StcsCompPlanResValues_CfMapEntry> = {
  encode(message: StcsCompPlanResValues_CfMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompPlanResValuesItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanResValues_CfMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanResValues_CfMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompPlanResValuesItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanResValues_CfMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompPlanResValuesItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompPlanResValues_CfMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompPlanResValuesItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanResValues_CfMapEntry>, I>>(
    base?: I,
  ): StcsCompPlanResValues_CfMapEntry {
    return StcsCompPlanResValues_CfMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanResValues_CfMapEntry>, I>>(
    object: I,
  ): StcsCompPlanResValues_CfMapEntry {
    const message = createBaseStcsCompPlanResValues_CfMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompPlanResValuesItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompPlanResValuesMeta(): StcsCompPlanResValuesMeta {
  return {
    ref_id_user: "",
    ref_id_org: "",
    ref_id_comp: "",
    fpna_begin_date_string: "",
    fpna_end_date_string: "",
    obj_created_iso_utc: "",
    obj_updated_iso_utc: "",
  };
}

export const StcsCompPlanResValuesMeta: MessageFns<StcsCompPlanResValuesMeta> = {
  encode(message: StcsCompPlanResValuesMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.fpna_begin_date_string !== "") {
      writer.uint32(42).string(message.fpna_begin_date_string);
    }
    if (message.fpna_end_date_string !== "") {
      writer.uint32(50).string(message.fpna_end_date_string);
    }
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(58).string(message.obj_created_iso_utc);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(66).string(message.obj_updated_iso_utc);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanResValuesMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanResValuesMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fpna_begin_date_string = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fpna_end_date_string = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanResValuesMeta {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      fpna_begin_date_string: isSet(object.fpna_begin_date_string)
        ? globalThis.String(object.fpna_begin_date_string)
        : "",
      fpna_end_date_string: isSet(object.fpna_end_date_string) ? globalThis.String(object.fpna_end_date_string) : "",
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
    };
  },

  toJSON(message: StcsCompPlanResValuesMeta): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.fpna_begin_date_string !== "") {
      obj.fpna_begin_date_string = message.fpna_begin_date_string;
    }
    if (message.fpna_end_date_string !== "") {
      obj.fpna_end_date_string = message.fpna_end_date_string;
    }
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanResValuesMeta>, I>>(base?: I): StcsCompPlanResValuesMeta {
    return StcsCompPlanResValuesMeta.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanResValuesMeta>, I>>(object: I): StcsCompPlanResValuesMeta {
    const message = createBaseStcsCompPlanResValuesMeta();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.fpna_begin_date_string = object.fpna_begin_date_string ?? "";
    message.fpna_end_date_string = object.fpna_end_date_string ?? "";
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    return message;
  },
};

function createBaseStcsCompPlanResValuesItem(): StcsCompPlanResValuesItem {
  return { values_map: {} };
}

export const StcsCompPlanResValuesItem: MessageFns<StcsCompPlanResValuesItem> = {
  encode(message: StcsCompPlanResValuesItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.values_map).forEach(([key, value]) => {
      StcsCompPlanResValuesItem_ValuesMapEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanResValuesItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanResValuesItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = StcsCompPlanResValuesItem_ValuesMapEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.values_map[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanResValuesItem {
    return {
      values_map: isObject(object.values_map)
        ? Object.entries(object.values_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StcsCompPlanResValuesItem): unknown {
    const obj: any = {};
    if (message.values_map) {
      const entries = Object.entries(message.values_map);
      if (entries.length > 0) {
        obj.values_map = {};
        entries.forEach(([k, v]) => {
          obj.values_map[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanResValuesItem>, I>>(base?: I): StcsCompPlanResValuesItem {
    return StcsCompPlanResValuesItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanResValuesItem>, I>>(object: I): StcsCompPlanResValuesItem {
    const message = createBaseStcsCompPlanResValuesItem();
    message.values_map = Object.entries(object.values_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStcsCompPlanResValuesItem_ValuesMapEntry(): StcsCompPlanResValuesItem_ValuesMapEntry {
  return { key: "", value: 0 };
}

export const StcsCompPlanResValuesItem_ValuesMapEntry: MessageFns<StcsCompPlanResValuesItem_ValuesMapEntry> = {
  encode(message: StcsCompPlanResValuesItem_ValuesMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompPlanResValuesItem_ValuesMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompPlanResValuesItem_ValuesMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompPlanResValuesItem_ValuesMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: StcsCompPlanResValuesItem_ValuesMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompPlanResValuesItem_ValuesMapEntry>, I>>(
    base?: I,
  ): StcsCompPlanResValuesItem_ValuesMapEntry {
    return StcsCompPlanResValuesItem_ValuesMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompPlanResValuesItem_ValuesMapEntry>, I>>(
    object: I,
  ): StcsCompPlanResValuesItem_ValuesMapEntry {
    const message = createBaseStcsCompPlanResValuesItem_ValuesMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
